import { CSSObject, SxProps, Theme } from '@mui/material'
import CustomPalette from '@/theme/CustomPalette'

const drawerWidth = 260

export const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
})

export const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(5.5)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7.5)} + 1px)`,
  },
})

export const drawerPaperStyles = (): CSSObject => ({
  backgroundColor: CustomPalette.SecondaryCloud,
  borderRight: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
})

export const drawerRootStyles = (theme: Theme, isOpen: boolean): SxProps<Theme> => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(isOpen && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': {
      ...openedMixin(theme),
      ...drawerPaperStyles(),
    },
  }),
  ...(!isOpen && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': {
      ...closedMixin(theme),
      ...drawerPaperStyles(),
    },
  }),
})

export const drawerHeaderStyles = (hasLogo: boolean): SxProps<Theme> => ({
  mt: 1,
  ml: hasLogo ? 0 : 1,
  mb: 6,
})

export const logoLinkStyles = (hasLogo: boolean): SxProps<Theme> => ({
  margin: hasLogo ? 'auto' : 0,
})
